import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpIcon } from '@heroicons/react/24/outline';

function BackToTopButton({ targetId = 'main-content' }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = document.getElementById(targetId) || window;
    const getScrollTop = () =>
      target === window ? window.scrollY : target.scrollTop;

    const onScroll = () => setVisible(getScrollTop() > 400);
    const el = target === window ? window : target;
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [targetId]);

  const scrollUp = () => {
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          initial={{ opacity: 0, scale: 0.8, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 12 }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.94 }}
          onClick={scrollUp}
          aria-label="Back to top"
          className="back-to-top-btn fixed bottom-6 right-6 z-[9990] flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-glow ring-1 ring-white/30 max-lg:safe-inset-bottom lg:bottom-8 lg:right-8"
        >
          <ArrowUpIcon className="h-5 w-5" strokeWidth={2} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}

export default BackToTopButton;
